import { getAnalyticsConfig, getHeadConfig, getLocale } from '@ynap/config-state'
import { ShoppingCart } from 'app/types/common-types'
import { createCombinedSelector } from '../utils/selectorUtils'
import { Config, Locale, StoreState } from 'app/state/types'

export default createCombinedSelector({
    name: 'getLoginStep',
    state: ['locale', 'config', 'cart', 'deviceType'],
    props: ['messages'],
    fn: getLoginStepInternal,
})

interface State extends StoreState {
    cart: ShoppingCart
    config: Config
    locale: Locale
}

export function getLoginStepInternal(state: State) {
    const { cart = {} } = state
    const { x_userStatus: userStatus, x_selfEmailAddress: logonId, orderItem = [] } = cart as ShoppingCart
    const { loginStep: { lowQualitySrc, highQualitySrc } = {}, links } = getHeadConfig(state)
    const locale = getLocale(state)
    const analytics = getAnalyticsConfig(state)

    const completed = userStatus ? !!userStatus : undefined
    const { language, country } = locale

    const initialValues = { logonId: logonId || (orderItem[0] && orderItem[0].email1), hasAccount: `${userStatus === 'R'}` }

    let parsedLinks = {}

    if (links) {
        parsedLinks = Object.keys(links).reduce((accumulator, currentValue) => {
            const link = links[currentValue]
            return { ...accumulator, ...{ [currentValue]: link.replace('{language}', language).replace('{country}', country.toLowerCase()) } }
        }, {})
    }

    return {
        userStatus,
        initialValues,
        completed,
        lowQualitySrc,
        highQualitySrc,
        links: parsedLinks,
        analytics,
        locale,
        logonId,
    }
}
